import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Autocomplete from '../common/Autocomplete'
import { administratorType } from '../common/types'

const Input = styled.input`
  border: 1px solid #a0a0a0;
  box-shadow: none;
  padding: 10px 13px 10px 20px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: none;
  font-size: 16px;
  &:focus {
    box-shadow: none !important;
    border: 1px solid #a0a0a0 !important;
  }
`
const InputControlsContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 7px;
`
const InputContainer = styled.div`
  width: 100%;
  position: relative;
`
const Item = styled.div`
  padding: 6px 0px 6px 20px;
  background: ${props => props.isHighlighted ? 'lightblue' : 'white'};
  cursor: pointer;
`
const Menu = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid #a0a0a0;
  margin-top: 1px;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 10000000;
  max-height: 8rem;
  overflow-y: scroll;
`
const Icon = styled.i`
  position: absolute;
  margin: auto 0;
  height: 12px;
  ${props => props.left ? `left: ${props.left};` : ''}
  ${props => props.right ? `right: ${props.right};` : ''}
  ${props => props.onClick ? 'cursor: pointer;' : ''}
  top: 0;
  bottom: 0;
  pointer-events: ${props => props.noPointerEvents ? 'none' : 'all'};
`


export default class AdminAutocomplete extends React.Component {
  constructor(props) {
    super(props)
    const { defaultValue, defaultItem } = props
    this.state = {
      value: defaultValue ? defaultValue : '',
      selectedItem: defaultItem ? defaultItem : {}
    }
  }
  static propTypes = {
    admins:         PropTypes.arrayOf(administratorType),
    defaultItem:    administratorType,
    defaultValue:   PropTypes.string,
    newAdmin:       PropTypes.bool,
    onAdminRemove:  PropTypes.func,
    onAdminSelect:  PropTypes.func.isRequired,
    selectedAdmins: PropTypes.arrayOf(administratorType)
  }
  shouldItemRender = (item, value) => {
    const { selectedAdmins } = this.props
    // Only show admins with matching names that haven't been selected yet
    const valueMatchesName = item.name.toLowerCase().includes(value.toLowerCase())
    const adminAlreadySelected = !selectedAdmins.every(admin => admin.rid !== item.rid)
    return valueMatchesName && !adminAlreadySelected
  }
  onChange = ({ target: { value } }) => {
    this.setState({ value })
  }
  onSelect = (value, item) => {
    const { onAdminSelect, newAdmin } = this.props
    const { selectedItem } = this.state
    onAdminSelect({ oldAdmin: selectedItem, newAdmin: item })
    if (!newAdmin) {
      this.setState({ value, selectedItem: item })
    } else {
      this.setState({ value: '', selectedItem: {} })
    }
  }
  onDelete = () => {
    const { selectedItem } = this.state
    const { onAdminRemove } = this.props
    onAdminRemove(selectedItem.rid)
  }
  renderInput = ({ onChange, ref, onFocus, onBlur, value, ...rest }) => {
    const { newAdmin } = this.props
    return (
      <InputControlsContainer>
        <InputContainer>
          <Icon
            bottom="30%"
            left="6px"
            className="fa fa-search"
            noPointerEvents
          />
          <Input
            {...rest}
            onFocus={onFocus}
            onBlur={onBlur}
            innerRef={ref}
            onChange={onChange}
            value={value}
            placeholder="Search names"
          />
          <Icon
            right="4%"
            bottom="30%"
            className="fa fa-chevron-down"
            noPointerEvents
          />
        </InputContainer>
        {
          !newAdmin && (
            <Icon
              right="-7%"
              className="fa fa-lg fa-times"
              onClick={this.onDelete}
            />
          )
        }
      </InputControlsContainer>
    )
  }
  renderItem = (item, isHighlighted) => (
    <Item isHighlighted={isHighlighted} key={item.rid}>
      {item.name}
    </Item>
  )
  renderMenu = items => {
    if (items.length > 0) {
      return (
        <Menu>
          {items}
        </Menu>
      )
    } else {
      return <div />
    }
  }
  render() {
    const { value } = this.state
    const { admins } = this.props
    return (
      <Autocomplete
        value={value}
        items={admins}
        getItemValue={item => item.name}
        onChange={this.onChange}
        onSelect={this.onSelect}
        renderInput={this.renderInput}
        renderMenu={this.renderMenu}
        renderItem={this.renderItem}
        wrapperStyle={{ width: '100%', position: 'relative' }}
        shouldItemRender={this.shouldItemRender}
      />
    )
  }
}
